<template>
    <div class="col-12 col-lg-12 mb-3" :data-fitter-element="fitter.cal_account_number">
        <div class="card fitter shadow-sm"
            :class="[parseInt(fitter.average_score) == 5 ? 'five-star' : '', getCustomFitterClass(fitter.cal_account_number)]"
            :id="fitter.id">
            <!-- small devices and above header -->
            <div class="card-header rounded-0 border-0 p-0 d-flex text-left text-dark justify-content-between align-items-center"
                :class="getCustomFitterClass(fitter.cal_account_number)">
                <span v-if="fitter.mobile == 0" class="marker-number cursor-pointer" :class="getCustomFitterClass(fitter.cal_account_number)" @click="highlightFitterOnMap()">
                    {{ fitter.mapIconNumber }}
                </span>
                <h3 class="p-3 m-0 text-capitalize me-auto d-block d-sm-inline-block" :class="{'cursor-pointer': fitter.mobile == 0 }" @click="fitter.mobile == 0 ? highlightFitterOnMap() : ''">
                    {{ fitter.name.toLowerCase() }}
                </h3>
                <div class="me-2">
                    <reviews :identifier="fitter.account_number" no-label></reviews>
                </div>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-12 col-md-6">
                        <span class="d-inline-flex align-items-center fw-bold rounded bg-premium text-white mb-2 px-2"
                            v-if="fitter.cal_account_number == 'CALFIT' || fitter.featured == true">
                            <span class="five-star-badge">
                                <i class="fa-solid fa-star me-2" style="color: #DFAA00;"></i>
                                <span>Premium Fitter</span>
                            </span>
                        </span>
                        <span class="d-inline-flex align-items-center fw-bold rounded bg-warning text-white mb-2 px-2"
                            v-else-if="fitter.average_score == 5">
                            <span class="five-star-badge text-black">
                                <i class="fas fa-award text-black me-2"></i>
                                <span>5 Star Fitter</span>
                            </span>
                        </span>
                        <!-- <span class="d-inline-block badge rounded-pill bg-warning text-dark mb-2 px-2" v-else-if="fitter.average_score == 5">
                            <span class="five-star-badge"><i class="fas fa-award text-dark fs-5 me-2"></i> 5 Star Fitter</span>
                        </span> -->
                        <b v-if="fitter.mobile == 0" class="text-16 d-block my-1">{{ parseFloat(fitter.distance, 2) }}
                            miles</b>
                        <div class="opening-times">
                            <div class="d-block">
                                <b class="text-16">Mon-Fri:</b><span class="text-16">&nbsp;{{ fitter.weekday }}</span>
                            </div>
                            <div class="d-block" v-if="fitter.saturday != '00:00-00:00'">
                                <b class="text-16">Sat:</b><span class="text-16">&nbsp;{{ fitter.saturday }}</span>
                            </div>
                            <div class="d-block" v-if="fitter.sunday != '00:00-00:00'">
                                <b class="text-16">Sun:</b><span class="text-16">&nbsp;{{ fitter.sunday }}</span>
                            </div>
                        </div>
                        <div v-if="fitter.mobile == 0" class="fitter-address fs-6 mt-1">
                            <p><span class="text-capitalize">{{ fitter.address_line_one.toLowerCase() }}</span>, {{
                                fitter.postcode }}</p>
                        </div>
                        <div class="mobile-fitter-msg alert text-black p-2 my-2" v-else>
                            <p class="mb-0">
                                Have this mobile fitter come to you for only <b>£{{ parseFloat(fitter.mobile_customer_surcharge).toFixed(2) }}</b> extra
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <VeeForm v-slot="{ handleSubmit, errors }" as="div" class="col-12">
                            <form ref="fitterForm" @submit="handleSubmit($event, selectFitter)" method="post"
                                :action="this.baseUrl + '/fitter-submit'" class="size-form">
                                <b class="text-16 d-block mb-1">Preferred fitting date {{ fitter.mobile == 0 ? '& time:'
                                    : '' }}</b>
                                <fitter-date-time :fitter="fitter" :mobile-fitting-slots="mobileFittingSlots"
                                    :errors="errors" :route="route" :update-fitting-time="true"
                                    :hide-labels="true"></fitter-date-time>
                                <div class="col-12" v-if="fitter.mobile == 1 && fitter.cal_account_number != 'CALTOTD'">
                                    <p class="mb-2">The fitter will contact you with a fitting time estimate.</p>
                                </div>
                                <div class="col-12">
                                    <input type="hidden" name="fitter_id" :value="fitter.account_number" />
                                    <button class="btn btn-primary form-control text-16"
                                        :data-fitter-submit-element="fitter.account_number"
                                        :disabled="(fitter.cal_account_number == 'CALTOTD' && dateSelected == false ? true : false)"
                                        type="submit">
                                        Select this {{ fitter.mobile == 1 ? 'mobile' : 'garage' }} fitter
                                    </button>
                                </div>
                            </form>
                        </VeeForm>
                    </div>
                    <div class="col-12" v-if="fitter.services.available.length > 0">
                        <hr class="mb-2" style="border-color: #E6E6E6;">
                        <div class="services">
                            <b class="text-16 mb-2 d-block">Services available</b>
                            <ul class="d-flex row row-cols-md-2 list-unstyled list-unstyled">
                                <li v-for="service in fitter.services.available" class="col text-16">
                                    <i class="fa-regular fa-circle-check text-primary me-1"></i>
                                    {{ service.name }} <div class="d-inline" v-if="service?.display_price"> - &pound;{{ service?.display_price }}</div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Form as VeeForm, Field , ErrorMessage} from 'vee-validate';
    import * as yup from 'yup';

    export default {
        props: ['fitter', 'mapIcons', 'route', 'mobileFittingSlots', 'view'],
        components: {
            VeeForm,
            Field,
            ErrorMessage
        },
        data() {
            return {
                dateSelected: false,
                disabled: false,
                fiveStars: true,
                appDate: Object.keys(this.fitter?.fitting_days)[0],
                appTime: ((this.fitter?.mobile == 0 || this.fitter?.cal_account_number == 'CALTOTD') ? Object.keys(this.fitter?.fitting_times)[0] : '')
            }
        },
        mounted() {
            this.emitter.on('updateSelectedAppDate', data => {
                this.appDate = data;
            });

            this.emitter.on('updateSelectedAppTime', data => {
                this.appTime = data;
            });
        },
        methods: {
            getCustomFitterClass(cal_account_number) {
                if(cal_account_number == 'CALFIT' || this.fitter.featured == true) {
                    return 'premium';
                }
                else if(this.fitter.mobile == 1) {
                    return 'mobile';
                }
            },
            highlightFitterOnMap() {
                this.emitter.emit('highlightFitterOnMap', this.fitter);
            },
            async selectFitter() {
                if(this.view == 'fittedNationally') {
                    var response = await axios.post('/ajax/fitter_modal_window/'+ this.fitter.account_number + '/' + this.appDate + '/' + this.appTime + '/' + this.fitter.distance + '/' + this.fitter.latitude + '/' + this.fitter.longitude);
                    
                    if(response) {
                        this.emitter.emit('openFitterModal', { fitter: this.fitter, sizeOptions: response.data.size_options, selectedAppDate: this.appDate, selectedAppTime: this.appTime, selectedFittingTimes: this.fitterTimes});
                    }
                }
                else {
                    this.emitter.emit('isLoading', true);
                    this.$refs.fitterForm.submit();
                }
            }
        },
        computed: {

        }
    }
</script>

<style lang="scss" scoped>
    .fitter {
        font-size: 14px;
        &.card {
            border-top-right-radius: 16px;
            border-top-left-radius: 16px;
        }
        &.five-star {
            .card-header {
                background-color: #212121;
                h3 {
                    color: #fff !important;
                }
            }
        }
        .card-header {
            border-top-right-radius: 14px !important;
            border-top-left-radius: 14px !important;
            h3 {
                font-size: 16px;
                font-weight: 500;
            }
        }
        .card-body {
            .five-star-badge {
                font-size: 16px;
                padding: 5px;
                svg {
                    color: #F7CC00;
                }
            }
            .fitting-date {
                select {
                    max-width: 155px;
                    height: 40px;
                    font-size: 14px;
                }
            }

        }
    }
</style>